import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d101aa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-availability-search__body" }
const _hoisted_2 = {
  key: 0,
  class: "service-availability-search__cart-notification-wrapper"
}
const _hoisted_3 = { class: "service-availability-search__cart-notification" }
const _hoisted_4 = { class: "service-availability-search__body-title" }
const _hoisted_5 = { class: "service-availability-search__body__logo" }
const _hoisted_6 = ["href"]

import BaseCard from '@/components/BaseCard.vue'
import { computed, PropType } from 'vue'
import { GroupedOption } from '@/models/shared.model'
import { PublicService } from '@/models/public/bookingWidget.model'
import VueMultiselect from 'vue-multiselect'
import { ServiceType } from '@/enums/services'
import {
  CompanyHousingDateAvailability,
  MinimumTimeslot,
} from '@/models/public/service.model'
import HousingCard from '@/components/booking-widget/HousingCard.vue'
import ExperienceCard from '@/components/booking-widget/ExperienceCard.vue'
import EventCard from '@/components/booking-widget/EventCard.vue'
import { Order } from '@/models/public/order.model'
import BaseIcon from '@/components/BaseIcon.vue'
import TicketCard from '@/components/booking-widget/TicketCard.vue'
import { ITicketItemDateAvailability } from '@/models/service/serviceTicket.model'
/* eslint-disable */

export default /*#__PURE__*/_defineComponent({
  __name: 'BookingComponent',
  props: {
  groupedOptions: {
    type: Array as PropType<GroupedOption[]>,
    default: () => [],
  },
  selectedService: {
    type: Object as PropType<PublicService | null>,
    default: null,
  },
  selectedStartDate: {
    type: [Date, null],
    default: null,
  },
  selectedEndDate: {
    type: [Date, null],
    default: null,
  },
  selectedAdultCount: {
    type: Number,
    default: 1,
  },
  selectedKidCount: {
    type: Number,
    default: 0,
  },
  housingAvailabilities: {
    type: Array as PropType<CompanyHousingDateAvailability[]>,
    default: () => [],
  },
  ticketAvailabilities: {
    type: Array as PropType<ITicketItemDateAvailability[]>,
    default: () => [],
  },
  selectedSlots: {
    type: Array as PropType<MinimumTimeslot[]>,
    default: () => [],
  },
  order: {
    type: Object as PropType<Order | null>,
    default: null,
  },
},
  emits: ["update:selectedStartDate", "update:selectedEndDate", "update:selectedService", "update:selectedAdultCount", "update:selectedKidCount", "update:order", "on-timeslot-select"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:selectedStartDate', newDate: Date): void
  (e: 'update:selectedEndDate', newDate: Date): void
  (e: 'update:selectedService', newService: PublicService): void
  (e: 'update:selectedAdultCount', newAdultCount: number): void
  (e: 'update:selectedKidCount', newKidCount: number): void
  (e: 'update:order', newOrder: Order): void
  (
    e: 'on-timeslot-select',
    slotId: number | undefined,
    shouldUnselect: boolean,
  ): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const spritePath = require('@/assets/icons/sprite.svg')

const GROUP_VALUES_PROP = 'items'
const GROUP_LABEL_PROP = 'key'





const startDate = computed({
  get: () => props.selectedStartDate,
  set: (value) => emit('update:selectedStartDate', value),
})

const endDate = computed({
  get: () => props.selectedEndDate,
  set: (value) => emit('update:selectedEndDate', value),
})

const adultCount = computed({
  get: () => props.selectedAdultCount,
  set: (value) => emit('update:selectedAdultCount', value),
})

const kidCount = computed({
  get: () => props.selectedKidCount,
  set: (value) => emit('update:selectedKidCount', value),
})

const computedOrder = computed({
  get: () => props.order,
  set: (value) => emit('update:order', value),
})

const customLabel = (option: PublicService) => {
  return option.name
}

function onSelectedServiceChange(newService: PublicService) {
  emit('update:selectedService', newService)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCard, {
    class: "service-availability-search",
    small: ""
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(computedOrder))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(BaseIcon, {
                icon: "shopping-cart-simple",
                class: "service-availability-search__cart-icon"
              }),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(computedOrder)?.order_items?.length), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('bookingWidget.whatWillYouBuy')), 1),
        _createVNode(_unref(VueMultiselect), _mergeProps({
          ref: "selectRef",
          options: __props.groupedOptions,
          "group-values": GROUP_VALUES_PROP,
          "group-label": GROUP_LABEL_PROP,
          label: '',
          "custom-label": customLabel,
          "close-on-select": true,
          "show-labels": false,
          "model-value": __props.selectedService,
          "select-label": _ctx.$t('bookingWidget.choose'),
          "deselect-label": _ctx.$t('bookingWidget.remove'),
          "selected-label": _ctx.$t('bookingWidget.chosen'),
          placeholder: _ctx.$t('bookingWidget.pickService'),
          "show-no-options": false
        }, _ctx.$attrs, {
          class: "service-availability-search__input service-availability-search__input--clickable",
          onSelect: onSelectedServiceChange
        }), {
          noResult: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('bookingWidget.noResults')), 1)
          ]),
          _: 1
        }, 16, ["options", "model-value", "select-label", "deselect-label", "selected-label", "placeholder"]),
        (__props.selectedService?.type === _unref(ServiceType).HOUSING)
          ? (_openBlock(), _createBlock(HousingCard, {
              key: 1,
              "selected-start-date": _unref(startDate),
              "onUpdate:selected-start-date": _cache[0] || (_cache[0] = ($event: any) => (_isRef(startDate) ? (startDate).value = $event : null)),
              "selected-end-date": _unref(endDate),
              "onUpdate:selected-end-date": _cache[1] || (_cache[1] = ($event: any) => (_isRef(endDate) ? (endDate).value = $event : null)),
              "selected-adult-count": _unref(adultCount),
              "onUpdate:selected-adult-count": _cache[2] || (_cache[2] = ($event: any) => (_isRef(adultCount) ? (adultCount).value = $event : null)),
              "selected-kid-count": _unref(kidCount),
              "onUpdate:selected-kid-count": _cache[3] || (_cache[3] = ($event: any) => (_isRef(kidCount) ? (kidCount).value = $event : null)),
              order: _unref(computedOrder),
              "onUpdate:order": _cache[4] || (_cache[4] = ($event: any) => (_isRef(computedOrder) ? (computedOrder).value = $event : null)),
              "selected-service": __props.selectedService,
              "housing-availabilities": __props.housingAvailabilities
            }, null, 8, ["selected-start-date", "selected-end-date", "selected-adult-count", "selected-kid-count", "order", "selected-service", "housing-availabilities"]))
          : _createCommentVNode("", true),
        (__props.selectedService?.type === _unref(ServiceType).EXPERIENCE)
          ? (_openBlock(), _createBlock(ExperienceCard, {
              key: 2,
              "selected-start-date": _unref(startDate),
              "onUpdate:selected-start-date": _cache[5] || (_cache[5] = ($event: any) => (_isRef(startDate) ? (startDate).value = $event : null)),
              "selected-adult-count": _unref(adultCount),
              "onUpdate:selected-adult-count": _cache[6] || (_cache[6] = ($event: any) => (_isRef(adultCount) ? (adultCount).value = $event : null)),
              order: _unref(computedOrder),
              "onUpdate:order": _cache[7] || (_cache[7] = ($event: any) => (_isRef(computedOrder) ? (computedOrder).value = $event : null)),
              "selected-service": __props.selectedService,
              "selected-slots": __props.selectedSlots
            }, null, 8, ["selected-start-date", "selected-adult-count", "order", "selected-service", "selected-slots"]))
          : _createCommentVNode("", true),
        (__props.selectedService?.type === _unref(ServiceType).EVENT)
          ? (_openBlock(), _createBlock(EventCard, {
              key: 3,
              "selected-start-date": _unref(startDate),
              "onUpdate:selected-start-date": _cache[8] || (_cache[8] = ($event: any) => (_isRef(startDate) ? (startDate).value = $event : null)),
              "selected-adult-count": _unref(adultCount),
              "onUpdate:selected-adult-count": _cache[9] || (_cache[9] = ($event: any) => (_isRef(adultCount) ? (adultCount).value = $event : null)),
              order: _unref(computedOrder),
              "onUpdate:order": _cache[10] || (_cache[10] = ($event: any) => (_isRef(computedOrder) ? (computedOrder).value = $event : null)),
              "selected-service": __props.selectedService,
              "selected-slots": __props.selectedSlots
            }, null, 8, ["selected-start-date", "selected-adult-count", "order", "selected-service", "selected-slots"]))
          : _createCommentVNode("", true),
        (__props.selectedService?.type === _unref(ServiceType).TICKET)
          ? (_openBlock(), _createBlock(TicketCard, {
              key: 4,
              "selected-start-date": _unref(startDate),
              "onUpdate:selected-start-date": _cache[11] || (_cache[11] = ($event: any) => (_isRef(startDate) ? (startDate).value = $event : null)),
              "selected-adult-count": _unref(adultCount),
              "onUpdate:selected-adult-count": _cache[12] || (_cache[12] = ($event: any) => (_isRef(adultCount) ? (adultCount).value = $event : null)),
              order: _unref(computedOrder),
              "onUpdate:order": _cache[13] || (_cache[13] = ($event: any) => (_isRef(computedOrder) ? (computedOrder).value = $event : null)),
              "selected-service": __props.selectedService,
              "selected-slots": __props.selectedSlots,
              "ticket-availabilities": __props.ticketAvailabilities,
              onOnTimeslotSelect: _cache[14] || (_cache[14] = (slotId, shouldUnselect) => emit('on-timeslot-select', slotId, shouldUnselect))
            }, null, 8, ["selected-start-date", "selected-adult-count", "order", "selected-service", "selected-slots", "ticket-availabilities"]))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(), _createElementBlock("svg", _hoisted_5, [
        _createElementVNode("use", {
          href: `${_unref(spritePath)}#icon-logo-with-name`
        }, null, 8, _hoisted_6)
      ]))
    ]),
    _: 1
  }))
}
}

})